export default __webpack_public_path__ + "static/media/Opposites03_18.35ba08b9.png";